/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios';
const apiUrl = 'https://starfish-app-i3bq6.ondigitalocean.app/';
const headers = { 'telegram-data': window.Telegram.WebApp.initData };
export class WithdrawService {
    constructor() {
        this._url = apiUrl;
        this._headers = headers;
    }
    handleError(error) {
        console.error(error);
        return undefined;
    }
    async makeGetRequest(url, data) {
        try {
            const config = { params: data, headers: this._headers };
            const res = await axios.get(`${this._url}${url}`, config);
            return res.data;
        }
        catch (error) {
            return this.handleError(error);
        }
    }
    async makePostRequest(url, data) {
        const res = await axios.post(`${this._url}${url}`, data, { headers: this._headers });
        return res.data;
    }
    async get(url, data) {
        return this.makeGetRequest(url, data);
    }
    async post(url, data) {
        return this.makePostRequest(url, data);
    }
    // ПОЛУЧЕНИЕ ИСТОРИИ ВЫВОДОВ
    async historyDeposits() {
        return this.get('withdraw/history', {});
    }
    //  СОЗДАНИЕ ВЫВОДА
    // BODY {amount: number, address: string}
    async createWithdraw(amount, address) {
        return this.post('withdraw', { amount, address });
    }
}
